<div class="modal-wrapper">
  <div class="modal" [ngClass]="{'normal-bg-color' : saveDataFlag === false, 'save-bg-color' : saveDataFlag === true, 'primary-bg-color' : primaryLayout === true}" role="dialog"
    id="modal-dialog" aria-label="dialog-label" aria-modal="true" tabindex="-1">
    <div class="modal-header ">
      <h4 class="modal-title " [ngClass]="{'normal-bg-color' : saveDataFlag === false, 'save-bg-color' : saveDataFlag === true, 'primary-bg-color-heading' : primaryLayout === true}"
      tabindex="0" [id]="modalConfig.modalType+'-header'" #closeBtnHeader>{{modalConfig.header}}</h4>
      @if (!primaryLayout) {
        <button #closeBtn id="btn-close-modal" class="position-absolute"type="button" (click)="close()"
          (keyup.enter)="close()" aria-label="close modal button">
          <span class="icon icon-cross reflect-modal-close" aria-label="close modal button" tabindex="0" aria-hidden="true" [ngClass]="{'save-icon' : saveDataFlag === true}"></span>
          <span class="visually-hidden">close modal</span>
      </button>
    }

  </div>
  <div class="modal-content">
    <span id="msgContent" [innerHTML]="modalConfig.content" aria-live="modalContent"></span>
  </div>
  <div class="modal-footer">
    <div class="clear-all sidebyside">
      <div #primaryBtn tabindex="0">
        @if (modalConfig.footerPrimaryBtnLabel !== '') {
          <button id="footer-primary" class="{{btnClass}}" [ngClass]="{'btn-secondary' : saveDataFlag === false,'btn-save' : saveDataFlag === true, 'btn-tooltip' : tooltipFlag === true, 'primary-bg-button' : primaryLayout === true}"
          type="button" (click)="primaryBtnClickHandler()">{{modalConfig.footerPrimaryBtnLabel}}</button>
        }
      </div>
      <div #secondaryBtn tabindex="0">
        @if (modalConfig.footerSecondaryBtnLabel !== '' && saveDataFlag === false) {
          <button id="footer-secondary" class="btn btn-chevron reflectChev-btn" [ngClass]="{'btn-secondary' : saveDataFlag === false,'btn-save' : saveDataFlag === true, 'btn-tooltip' : tooltipFlag === true}" type="button" (click)="secondaryBtnClickHandler()"
          >{{modalConfig.footerSecondaryBtnLabel}}</button>
        }
      </div>
    </div>

    @if (saveDataFlag === true && checkUrl()) {
      <div class="col-md-6 text-right" [ngClass]="{'padding-top-10':(saveDataFlag === true && checkUrl()) ||(saveDataFlag === false || (saveDataFlag === true && loginDetail))}">
        <div >
          @if (modalConfig.checkMessage && checkUrl()) {
            <div class="form-field dont-show-msg" tabindex="0">
              <div class="form-field dont-show-msg" #secondaryBtn tabindex="0">
                <a id="mcLink" name="mcLink" tabindex="0" (click)="navTo()" (keyup.enter)="navTo()" class="form-label returnTomyQuote">{{modalConfig.checkMessage}}</a>
              </div>
            </div>
          }
        </div>
        <ng-template #registerButton>
          <div class="col-md-6 text-right save-register-padding-right">
            @if (modalConfig.footerSecondaryBtnLabel !== '') {
              <button id="footer-register" class="btn btn-save btn-chevron reflectChev-btn" type="button" (click)="secondaryBtnClickHandler()"
              >{{modalConfig.footerSecondaryBtnLabel}}</button>
            }
          </div>
        </ng-template>
      </div>
    }
  </div>
</div>